import React from 'react';

export type ModelId = 'gemini-2.5-flash-image' | 'gemini-3-pro-image-preview' | 'gemini-3-flash-preview';

export interface ProcessedImage {
  originalUrl: string;
  processedUrl: string | null;
  mimeType: string;
  originalBase64: string; // Stored without prefix for API
}

export enum AppStatus {
  IDLE = 'IDLE',
  UPLOADING = 'UPLOADING',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR'
}

export interface PresetPrompt {
  id: string;
  label: string;
  prompt: string;
  icon: React.ReactNode;
  description: string;
}

export interface ProcessingError {
  message: string;
  details?: string;
}

export interface TokenUsage {
  promptTokens: number;
  candidateTokens: number;
  totalTokens: number;
}

export interface StepConfig {
  imageConfig?: any; // For Gemini config
  generationConfig?: any; // For temperature/topK etc
  backgroundColor?: 'white' | 'black' | 'blue' | 'green' | 'transparent';
}

export interface WorkflowStep {
  id: string; // Unique ID for the queue item
  type: 'preset' | 'custom';
  label: string;
  prompt: string;
  status: 'pending' | 'processing' | 'complete' | 'error' | 'skipped';
  resultUrl?: string | null;

  // New fields for advanced workflow
  readOnly?: boolean;        // If true, user cannot edit the prompt
  outputType?: 'image' | 'text'; // Defaults to 'image'
  resultText?: string | null; // Stores text output if outputType is 'text'
  usage?: TokenUsage; // Token usage for this specific step
  selectedModel?: ModelId; // The model used for this step

  // Distinguish between AI generation and Client-side manipulation
  operation?: 'gemini';

  config?: StepConfig;

  // For masking workflow: identifies that this step produces a mask for the next step
  isMaskGenerator?: boolean;
}